var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "show-premium-modal" },
    [
      _c("m-items", {
        attrs: {
          "modal-confirm": true,
          active: _vm.isShowConfirmModal,
          "modal-title": "Удаление премии",
          "modal-description":
            "При удалении премии сумма средств на личном счете сотрудника изменится",
        },
        on: {
          close: function ($event) {
            _vm.isShowConfirmModal = false
          },
          removeItemRequest: _vm.removeItemRequest,
        },
      }),
      _c("m-write-premium", {
        attrs: {
          "calc-data": _vm.calcData,
          record: _vm.record,
          active: _vm.isShowWritePremiumModal,
          "edit-premium-data": _vm.editPremiumDataLocal,
        },
        on: {
          close: function ($event) {
            _vm.isShowWritePremiumModal = false
          },
          createPremium: _vm.createPremium,
          editPremium: _vm.editPremium,
        },
      }),
      _c(
        "b-modal",
        {
          attrs: {
            id: "calculationsShowPremiumModal",
            size: "custom-size",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          on: {
            show: _vm.onShowModal,
            close: function ($event) {
              _vm.localActive = false
            },
          },
          model: {
            value: _vm.localActive,
            callback: function ($$v) {
              _vm.localActive = $$v
            },
            expression: "localActive",
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "show-premium-modal-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: {
                click: function ($event) {
                  _vm.localActive = false
                },
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _c(
            "div",
            { staticClass: "show-premium-modal-fullname" },
            [
              _c(
                "div",
                { staticClass: "show-premium-modal-fullname-description" },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "16",
                        height: "18",
                        viewBox: "0 0 16 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M13.9902 16.0625C13.9902 16.6148 14.4379 17.0625 14.9902 17.0625C15.5425 17.0625 15.9902 16.6148 15.9902 16.0625H13.9902ZM11.2513 10.9863V9.98628V10.9863ZM4.73896 10.9863V9.98628V10.9863ZM1 14.9745H0H1ZM0 16.0625C0 16.6148 0.447715 17.0625 1 17.0625C1.55228 17.0625 2 16.6148 2 16.0625H0ZM15.9902 16.0625V14.9745H13.9902V16.0625H15.9902ZM15.9902 14.9745C15.9902 13.6716 15.5056 12.4102 14.6246 11.4705L13.1656 12.8383C13.687 13.3945 13.9902 14.1619 13.9902 14.9745H15.9902ZM14.6246 11.4705C13.7416 10.5286 12.5297 9.98628 11.2513 9.98628V11.9863C11.9561 11.9863 12.6462 12.2843 13.1656 12.8383L14.6246 11.4705ZM11.2513 9.98628H4.73896V11.9863H11.2513V9.98628ZM4.73896 9.98628C3.46052 9.98628 2.24859 10.5286 1.36558 11.4705L2.82465 12.8383C3.34403 12.2843 4.03413 11.9863 4.73896 11.9863V9.98628ZM1.36558 11.4705C0.484619 12.4102 0 13.6716 0 14.9745H2C2 14.1619 2.30323 13.3945 2.82465 12.8383L1.36558 11.4705ZM0 14.9745V16.0625H2V14.9745H0ZM9.95503 3.99117C9.95503 5.09086 9.06355 5.98234 7.96386 5.98234V7.98234C10.1681 7.98234 11.955 6.19543 11.955 3.99117H9.95503ZM7.96386 5.98234C6.86417 5.98234 5.97269 5.09086 5.97269 3.99117H3.97269C3.97269 6.19543 5.7596 7.98234 7.96386 7.98234V5.98234ZM5.97269 3.99117C5.97269 2.89148 6.86417 2 7.96386 2V0C5.7596 0 3.97269 1.78691 3.97269 3.99117H5.97269ZM7.96386 2C9.06355 2 9.95503 2.89148 9.95503 3.99117H11.955C11.955 1.78691 10.1681 0 7.96386 0V2Z",
                          fill: "#8E9CBB",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "show-premium-modal-fullname-description-text",
                    },
                    [_vm._v(_vm._s(_vm.record.employee.value))]
                  ),
                ]
              ),
              _c("c-button", {
                attrs: { label: "Добавить премию", size: "small" },
                on: { click: _vm.showModalAddNewPremium },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "show-premium-modal-header show-premium-modal-header-green",
            },
            [
              _c("div", { staticClass: "show-premium-modal-header-title" }, [
                _vm._v("Премии"),
              ]),
              _c("div", { staticClass: "show-premium-modal-header-count" }, [
                _c(
                  "div",
                  { staticClass: "show-premium-modal-header-count-text" },
                  [_vm._v(_vm._s(_vm.getCountForHeader()))]
                ),
              ]),
              _c("div", { staticClass: "show-premium-modal-header-amount" }, [
                _vm._v(_vm._s(_vm.getCommonAmount())),
                _c("span", [_vm._v(" ฿")]),
              ]),
            ]
          ),
          _vm.itemsLocal.length > 0
            ? _c(
                "div",
                { staticClass: "show-premium-modal-search" },
                [
                  _c("c-input", {
                    staticClass: "show-premium-modal-search-input",
                    attrs: {
                      id: "show-premium-modal-search-input",
                      placeholder: "Поиск",
                      icon: "search",
                      type: "text",
                      clearable: true,
                    },
                    model: {
                      value: _vm.searchLocal,
                      callback: function ($$v) {
                        _vm.searchLocal = $$v
                      },
                      expression: "searchLocal",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "show-premium-modal-items",
              attrs: { id: "show-premium-modal-items" },
              on: { scroll: _vm.setShadowSummaryItems },
            },
            [
              _vm._l(_vm.itemsLocal, function (item, itemIndex) {
                return item.isShow
                  ? _c(
                      "div",
                      {
                        key: itemIndex,
                        staticClass: "show-premium-modal-items-item",
                      },
                      [
                        item.isShow
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "show-premium-modal-items-item-desc",
                                },
                                [_vm._v(_vm._s(item.reason))]
                              ),
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "show-premium-modal-items-item-date",
                                    },
                                    [_vm._v(_vm._s(item.date))]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "show-premium-modal-items-item-amount",
                                    },
                                    [
                                      _vm._v(_vm._s(item.amount)),
                                      _c("span", [_vm._v(" ฿")]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "show-premium-modal-items-item-buttons",
                                    },
                                    [
                                      item.calc_id !== null &&
                                      item.calc_id !== undefined
                                        ? _c("c-button", {
                                            directives: [
                                              {
                                                name: "b-popover",
                                                rawName: "v-b-popover.html",
                                                value: {
                                                  container:
                                                    "#calculationsShowFinesModal",
                                                  trigger: "hover blur",
                                                  boundary: "window",
                                                  content:
                                                    "Перейти в сохранённый расчёт",
                                                  placement: "top",
                                                },
                                                expression:
                                                  "{\n                  container: '#calculationsShowFinesModal',\n                  trigger: 'hover blur',\n                  boundary: 'window',\n                  content: 'Перейти в сохранённый расчёт',\n                  placement: 'top',\n                }",
                                                modifiers: { html: true },
                                              },
                                            ],
                                            key: item.calc_id,
                                            staticClass:
                                              "show-premium-modal-items-item-buttons-calculate",
                                            attrs: {
                                              size: "iconic",
                                              icon: "calculate",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openCalc(
                                                  item.calc_id
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _c("c-button", {
                                        directives: [
                                          {
                                            name: "b-popover",
                                            rawName: "v-b-popover.html",
                                            value: {
                                              container:
                                                "#calculationsShowFinesModal",
                                              trigger: "hover blur",
                                              boundary: "window",
                                              content: "Редактировать",
                                              placement: "top",
                                            },
                                            expression:
                                              "{\n                  container: '#calculationsShowFinesModal',\n                  trigger: 'hover blur',\n                  boundary: 'window',\n                  content: 'Редактировать',\n                  placement: 'top',\n                }",
                                            modifiers: { html: true },
                                          },
                                        ],
                                        staticClass:
                                          "show-premium-modal-items-item-buttons-edit",
                                        attrs: { size: "iconic", icon: "edit" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showEditPremiumModal(
                                              item,
                                              itemIndex
                                            )
                                          },
                                        },
                                      }),
                                      !item.is_external
                                        ? _c("c-button", {
                                            directives: [
                                              {
                                                name: "b-popover",
                                                rawName: "v-b-popover.html",
                                                value: {
                                                  container:
                                                    "#calculationsShowFinesModal",
                                                  trigger: "hover blur",
                                                  boundary: "window",
                                                  content: "Удалить",
                                                  placement: "top",
                                                },
                                                expression:
                                                  "{\n                  container: '#calculationsShowFinesModal',\n                  trigger: 'hover blur',\n                  boundary: 'window',\n                  content: 'Удалить',\n                  placement: 'top',\n                }",
                                                modifiers: { html: true },
                                              },
                                            ],
                                            staticClass:
                                              "show-premium-modal-items-item-buttons-trash",
                                            attrs: {
                                              size: "iconic",
                                              icon: "trash",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showConfirmRemoveModal(
                                                  itemIndex
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e()
              }),
              _vm.isShowSearchEmptyMessage || _vm.itemsLocal.length === 0
                ? _c("div", { staticClass: "show-premium-modal-items-empty" }, [
                    _vm._v(" Премии не найдены "),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _c("div", {
            staticClass: "show-premium-modal-items-shadow-bottom",
            attrs: { id: "show-premium-modal-items-shadow-bottom" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }